/**
 * @generated SignedSource<<29bca5d6cc520c9004dedd0c40a14f44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkQrCode_pixQrCode$data = {
  readonly brCode: string | null | undefined;
  readonly " $fragmentType": "PaymentLinkQrCode_pixQrCode";
};
export type PaymentLinkQrCode_pixQrCode$key = {
  readonly " $data"?: PaymentLinkQrCode_pixQrCode$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkQrCode_pixQrCode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkQrCode_pixQrCode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brCode",
      "storageKey": null
    }
  ],
  "type": "PixQrCode",
  "abstractKey": null
};

(node as any).hash = "4db051f39df05467cc16c019f13ae649";

export default node;
